import { render, staticRenderFns } from "./FlipBook.vue?vue&type=template&id=4b0cd45b&scoped=true&"
import script from "./FlipBook.vue?vue&type=script&lang=js&"
export * from "./FlipBook.vue?vue&type=script&lang=js&"
import style0 from "./FlipBook.vue?vue&type=style&index=0&id=4b0cd45b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0cd45b",
  null
  
)

export default component.exports